const initialState = {
  loading: true
};

const loadingTranslations = (state = initialState, action) => {
  switch (action.type) {
    case 'LOADING_TRANSLATIONS':
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};

export default loadingTranslations;
